import { action } from 'satcheljs';
import CalendarReminder from 'owa-service/lib/contract/CalendarReminder';

/**
 * Called when there is a change in the default reminder dropdown
 */

let selectReminderDefaultTimeOption = action(
    'selectReminderDefaultTimeOption',
    (defaultReminderTime: CalendarReminder) => ({
        defaultReminderTime,
    })
);

export default selectReminderDefaultTimeOption;
